module.exports = __webpack_public_path__ + "img/shipo-icon-delete-primary.c4eeed3b.svg";